module.exports = __webpack_public_path__ + "static/media/bet-blue-3.2e7b9647.png";